import React from 'react'
import Button from '@bt-react/components/Button'
import Icon, { IconType } from '@bt-react/components/Icon'
import styles from './AudioSwitch.module.scss'
import { AudioSwitchProps } from './types'

const AudioSwitch: React.FC<AudioSwitchProps> = props => {

  const isMicrophoneSelected = props.selected === 'microphone'
  const isDialInSelected = props.selected === 'telephone'

  return <div className={styles['audio-selection-container']} data-bdd='audio-switch'>
    <Button
      className={styles['audio-selection-btn']}
      color={isMicrophoneSelected ? IconType.colour.brightTALK : IconType.colour.secondary}
      onClick={() => props.onClick('microphone')}
      dataBdd='audio-selection-microphone'
    >
      <Icon
        colour={isMicrophoneSelected ? IconType.colour.white : IconType.colour.white}
        name={IconType.iconName.microphone}
      />
    </Button>
    <Button
      className={styles['audio-selection-btn']}
      color={isDialInSelected ? IconType.colour.brightTALK : IconType.colour.secondary}
      onClick={() => props.onClick('telephone')}
      dataBdd='audio-selection-dial-in'
    >
      <Icon
        colour={isDialInSelected ? IconType.colour.white : IconType.colour.white}
        name={IconType.iconName.phone}
      />
    </Button>
  </div>

}

export default AudioSwitch
